import { render, staticRenderFns } from "./SwitchWrap.vue?vue&type=template&id=60d89716&scoped=true&"
import script from "./SwitchWrap.vue?vue&type=script&lang=js&"
export * from "./SwitchWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d89716",
  null
  
)

export default component.exports